module.exports = __webpack_public_path__ + "img/bg-question-desktop.bff70515.png";